<script setup lang="ts">
import { useIsMobile } from '@/composables/useMediaQuery'
import type { Article } from '@/types/article.types'
import { useRouter } from 'vue-router'

defineProps<{
  item: Article
}>()

const router = useRouter()
const isMobile = useIsMobile()
const handleItemClick = (item: Article) => {
  router.push(`/post/${item.idx}`)
}

const formatDate = (date: number) => {
  const dateObj = new Date(date)

  const year = dateObj.getFullYear().toString().substring(2).padStart(2, '0')
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
  const day = dateObj.getDate().toString().padStart(2, '0')

  return `${year}.${month}.${day}`
}
</script>

<template>
  <div class="post-item" @click="handleItemClick(item)">
    <div class="post-thumbnail">
      <img :src="item.thumbnailUrl" alt="게시글 썸네일" />
    </div>
    <div class="post-content">
      <div class="post-title-wrapper">
        <div class="post-title title-sm white">{{ item.title }}</div>
        <div v-if="!isMobile" class="right-chevron svg-24 svg-white">
          <img src="@/assets/svgs/chevron_right.svg" alt="오른쪽 체크 아이콘" />
        </div>
      </div>
      <div class="post-meta">
        <span class="post-date sub-md gray-600">{{ formatDate(item.createdAt) }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.post-item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.post-item:hover {
  transform: translateY(-5px);
}

.post-thumbnail {
  width: 100%;
  height: 100%;
  aspect-ratio: 413 / 232;
  overflow: hidden;
}

.post-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.post-content {
  padding: 0px;
}

.post-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.post-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.level-tag {
  padding: 2px 8px;
  background-color: var(--tint-300);
  border-radius: 4px;
  color: var(--gray-900);
}

.empty-state {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px 0;
}

@media (max-width: 1365px) {
  .post-item {
    width: 100%;
  }

  .post-item:hover {
    transform: translateY(0px);
  }

  .post-thumbnail {
    aspect-ratio: 375/ 210;
  }

  .post-thumbnail img {
    border-radius: 0px;
  }

  .post-content {
    padding: 0 20px;
  }
}
</style>
